import {
  UserProfileMessage,
  UserProfileMessageType,
  UserProfileUpdatedPayload,
} from '@playcastdotio/Messaging';
import { userProfileState } from '../../../stores/shared';

export const handleUserProfileMessage = (message: UserProfileMessage) => {
  switch (message.type) {
    case UserProfileMessageType.USER_PROFILE_UPDATED: {
      const payload = message as unknown as UserProfileUpdatedPayload & { type: string };
      userProfileState.updateState({
        authId: payload.authId,
        pointsBalance: payload.pointsBalance,
        totalPointsEarned: payload.totalPointsEarned,
        rank: payload.rank,
        legacyDays: payload.legacyDays,
        timezoneOffsetMinutes: payload.timezoneOffsetMinutes,
        firstSeenAt: payload.firstSeenAt,
        lastSeenAt: payload.lastSeenAt,
        frozenAt: payload.frozenAt,
        frozenReason: payload.frozenReason,
        createdAt: payload.createdAt,
        updatedAt: payload.updatedAt,
      });
      break;
    }
  }
};
